import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/petwell-magento-shopify-plus-migration-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/petwell-magento-migration-case-study", statusCode: 301 });
  },
});
